import React from 'react';
import withAuthentication from 'hoc/withAuthentication';

const Home = () => <div>Home</div>;

export default withAuthentication(Home);
